import { defaultLocale } from 'lib/storeLocales/storeLocales';
import { getLinkHref, capitalize } from 'lib/utils/helpers';
import Head from 'next/head';
import { useRouter } from 'next/router';

const baseUrl = process.env.NEXT_PUBLIC_SITEURL;
const siteName = process.env.NEXT_PUBLIC_SITENAME;

const ProductListingStructuredData = ({ page, products }) => {
  const { asPath, locale } = useRouter();

  if (!page) return null;

  const { seo, title } = page;
  const { description } = seo;

  const image = seo.image?.url;

  const pathWithoutQueryOrAnchor = `${asPath.split('/').slice(0, -1).join('/')}/`;
  const localePath = locale && locale !== defaultLocale ? `/${locale}` : '';
  const url = `${baseUrl}${localePath}${pathWithoutQueryOrAnchor}`;

  return (
    <Head>
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'http://schema.org',
            '@type': 'WebPage',
            name: capitalize(siteName),
            url,
            mainEntity: {
              '@type': 'offerCatalog',
              name: title,
              url,
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: title,
                item: url,
              },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'http://schema.org',
            '@type': 'CollectionPage',
            name: title,
            url,
            description,
            image,
            mainEntity: {
              '@type': 'ItemList',
              itemListElement: products?.map((product, index) => ({
                '@type': 'ListItem',
                position: index + 1,
                url: getLinkHref({ __typename: 'PageProduct', slug: product.slug }),
              })),
            },
          }),
        }}
      />
    </Head>
  );
};

export default ProductListingStructuredData;
